.button {
    position: absolute;
    top: var(--spacer-16);
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    backdrop-filter: blur(10px);
    background-color: var(--black);
    border: 1px solid var(--gray-700);
    border-radius: 240px;
    color: var(--off-white);
    cursor: pointer;
    font: var(--font-button-18);
    letter-spacing: 0.54px;
    padding: var(--spacer-16) var(--spacer-24);
    white-space: nowrap;
}
